// Smazání/obnovení komentáře

import { prepareFormData } from '@utils/form';
import * as els from './forumElements';
import * as api from './forumApi';
import { formChangeStatusComment as changeStatus } from './formChangeStatusComment';
import { FlashMessage } from '@components';

interface ModalDeleteState {
  msg: string;
  isDeleted: boolean;
}

//  TODO: unit testy https://cncenter.atlassian.net/browse/FEG-657
export const forumDeleteComment = (): void => {
  // UI a data modalu
  let state: ModalDeleteState;
  const modal = els.modalDelete;

  if (!modal) return;

  const buttonSave: HTMLButtonElement | null = modal.querySelector('[data-save-delete-comment]');
  const { threadId, threadTitle } = modal.dataset;

  if (!buttonSave || !threadId || !threadTitle) return;

  // Pro všechny tlačítka 'Smazat/Obnovit'
  els.buttonsDelete.forEach((button) => {
    // Po kliknutí
    button.addEventListener('click', (e) => {
      // Načíst data komentáře
      const { deleteComment: commentId, deleteCommentStatus: statusId } = button.dataset;
      const isDeleted = statusId === '0';

      if (!commentId || !statusId || !e.target) return;

      // Změnit stav modalu
      state = {
        msg: commentId,
        isDeleted,
      };

      // Nastavit titulek, text a tlačítko v modálním okně
      const modalTitle: HTMLDivElement | null = modal.querySelector('.modal__title');
      const modalButton: HTMLButtonElement | null = modal.querySelector(
        '[data-save-delete-comment]'
      );
      const modalButtonText: HTMLDivElement | null = modalButton
        ? modalButton.querySelector('.button__text')
        : null;
      const modalBody: HTMLDivElement | null = modal.querySelector('.modal__body');

      if (!modalTitle || !modalButton || !modalBody) return;

      modalTitle.innerText = `${isDeleted ? 'Obnovit' : 'Smazat'} komentář`;
      if (modalButtonText) modalButtonText.innerText = isDeleted ? 'Obnovit' : 'Smazat';

      // Pokud je příspěvek aktuálně ve stavu 'smazán', přidat do těla modálního okna otázku
      if (isDeleted) {
        modalBody.innerHTML = `<span class="typography typography--body1">Opravdu chcete tento komentář obnovit?</span>`;
      }
    });
  });

  // V modálním okně po kliknutí na potvrzovací tlačítko
  buttonSave.addEventListener('click', () => {
    const { msg, isDeleted } = state;

    if (!msg) return;

    // Změnit stav
    const toggleState = isDeleted ? '1' : '0';

    let reasonValue = '';
    let textareaValue = '';
    if (!isDeleted) {
      // Získat vybranou hodnotu radio buttonu (důvody pro smazání)
      const selectedReason = modal.querySelector(
        'input[name="deleteReason"]:checked'
      ) as HTMLInputElement;
      reasonValue = selectedReason ? selectedReason.value : '';

      // Získat obsah textarea (specifický komentář jako důvod pro smazání)
      const textarea = modal.querySelector(
        'textarea[name="deleteReasonText"]'
      ) as HTMLTextAreaElement;
      textareaValue = textarea ? textarea.value : '';

      // Validace | Musí být vybrán důvod smazání
      if (!reasonValue) {
        FlashMessage({
          msg: 'Vyberte důvod smazání komentáře.',
          type: 'error',
        });

        return;
      }

      // Validace | Pokud je vybrán důvod 'Jiné zákonné důvody' a není vyplněn textarea
      const OTHERS = '1000';
      if (reasonValue === OTHERS && !textareaValue) {
        FlashMessage({
          msg: 'Vyplňte prosím textové pole.',
          type: 'error',
        });
        return;
      }
    }

    // Přípravit data
    const requestData = prepareFormData({
      msg,
      status: toggleState,
      ajax: '1',
      reason: reasonValue,
      message: textareaValue,
      threadTitle,
    });

    // Odeslat data
    changeStatus({
      apiRoute: api.status(threadId),
      requestData,
      successMessage: `Komentář byl ${isDeleted ? 'obnoven' : 'smazán'}.`,
    });

    // Skrýt modal
    els.closeModal(modal);
  });
};
